@if(uploadForm) {
<div class="load-docs-container">
  <h2>Carica file</h2>
  <form [formGroup]="uploadForm" nz-form nzLayout="vertical" class="upload-layout">
    <!-- Area di caricamento -->
    @if (!document && !documentIsUploading) {
      <nz-upload
        [nzBeforeUpload]="beforeUpload"
        nzListType="text"
        [nzMultiple]="false"
        [nzShowUploadList]="false"
        nzType="drag"
      >
        <div class="upload-area">
          <span nz-icon nzType="inbox" nzTheme="outline"></span>
          <p class="upload-message">
            <span class="upload-link">{{'toastr.loadDocuments.clickHere' | translate}}</span> {{'toastr.loadDocuments.moveFile' | translate}}
          </p>
        </div>
      </nz-upload>
    }

    @if (!document && documentIsUploading) {
      <nz-progress [nzPercent]="progressPercentage"></nz-progress>
    }

    @if (document && !documentIsUploading) {
      <span>Documento caricato</span>
      <div class="document-container">
        <span class="document">{{ document.name }}</span>
        <span class="delete-doc" role="button" tabindex="0" (click)="deleteDoc()" (keydown.enter)="deleteDoc()" (keydown.space)="deleteDoc(); $event.preventDefault()">
          <span nz-icon nzType="rest" nzTheme="outline"></span>
            {{'loadDocumentModal.delete' | translate}}
        </span>
      </div>
    }

    <ds-input-text
      [control]="uploadForm.get('docName')"
      [placeholder]="'loadDocumentModal.placeholder_title' | translate"
      [label]="'loadDocumentModal.doc_title' | translate"
    ></ds-input-text>

    <app-aria-date-picker-field
      formControlName="docDate"
      [placeholder]="'loadDocumentModal.insert' | translate"
      [minDate]="startDateDocument"
      [maxDate]="endDateDocument"
      [label]="'loadDocumentModal.doc_date' | translate"
      mode="single"
      mobileDrawer="auto"
      ></app-aria-date-picker-field>

    <!-- Tipologia documento -->
    <nz-form-item>
      <nz-form-label [nzFor]="'documentType'">{{'loadDocumentModal.service_type' | translate}}</nz-form-label>
      <nz-radio-group role="radiogroup" aria-label="Seleziona la tipologia di documento" formControlName="documentType">
        <label nz-radio nzValue="Referto visita" aria-label="Referto visita">{{'loadDocumentModal.visit_report' | translate}}</label>
        <label nz-radio nzValue="Referto esame diagnostico" aria-label="Referto esame diagnostico">{{'loadDocumentModal.diagnostic_report' | translate}}</label>
        <label nz-radio nzValue="Referto analisi del sangue" aria-label="Referto analisi del sangue">{{'loadDocumentModal.blood_report' | translate}}</label>
      </nz-radio-group>
    </nz-form-item>

    @if(pathologyItemsSelect.length > 0) {
      <div class="pathology-container">
        <app-aria-autocomplete-field
          [placeholder]="'loadDocumentModal.select' | translate"
          [label]="'loadDocumentModal.pathology' | translate"
          [options]="pathologyItemsSelect"
          formControlName="docPathology"
        ></app-aria-autocomplete-field>
      </div>
    }
    <ds-input-area
      [control]="uploadForm.get('docNote')"
      [placeholder]="'loadDocumentModal.notes' | translate"
      [label]="'loadDocumentModal.additional_notes' | translate"
    >
    </ds-input-area>
    <div class="reminder">
      <p>{{'loadDocumentModal.reminder' | translate}}</p>
    </div>
  </form>
  <div class="buttons">
    <ds-button class="button-exit" [text]="'buttons.exit' | translate" [width]="'small'" [styleType]="'empty-main'" (click)="closeModal()"></ds-button>
    <ds-button class="button-save" [text]="'buttons.save' | translate" [width]="'small'" (click)="sendData()" [isDisabled]="uploadForm.invalid || !this.document"></ds-button>
  </div>

</div>
}
